import { FrogArticleDetailRespDTO } from "@/service/customer";
import { useTranslation } from "react-i18next";

interface ShareCompProsp{
  frogArticle?:FrogArticleDetailRespDTO
}
const ShareComp= ({frogArticle}:ShareCompProsp) => {
    const { t } = useTranslation();
  return (
    <div className="float-right flex items-center gap-2">
      <span>{t('分享至')}：</span>
      <img
      className="w-[24px] cursor-pointer"
        src="https://static-s.theckb.com/kaerumedia/share_icon_twitter.png"
        alt=""
        onClick={()=>{
          window.open(`https://twitter.com/intent/tweet?text=${frogArticle?.frogArticleTitle}&url=${encodeURIComponent(location.href)}`)
        }}
      />
      <img className="w-[24px] cursor-pointer"
        src="https://static-s.theckb.com/kaerumedia/share_icon_facebook.png"
        alt=""
        onClick={()=>{
          window.open(`http://www.facebook.com/sharer/sharer.php?t=${frogArticle?.frogArticleTitle}&u=${encodeURIComponent(location.href)}`)
        }}
      />
      {/* <img className="w-[24px] cursor-pointer"
        src="https://static-s.theckb.com/kaerumedia/share_icon_ins.png"
        alt=""
      />  */}
      <img className="w-[24px] cursor-pointer"
        src="https://static-s.theckb.com/kaerumedia/share_icon_line.png"
        onClick={()=>{
          window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(location.href)}`)
        }}
        alt=""
      />
    </div>
  );
};

export default ShareComp;